export const AUTH_ROLES = {
    SUPER: 'super',
    TOTAL: 'total',
    OWNER: 'owner',
    REGIONAL: 'regional',
    ADMIN: 'admin',
    USER: 'user',
}
